import axios from "axios";
axios.defaults.withCredentials = true;
const access_token = localStorage.getItem('auth-token') || '';

export default axios.create({
  baseURL: 'https://marvels.soccerslot.xyz',
  headers: {
    "Content-type": "application/json",
    withCredentials: true,
    Authorization: `Bearer ${access_token}`
  }
});